<template>
  <v-list two-line color="color-2">
    <v-list-item v-for="cb in callbacks" :key="'cb'+cb.id">
      <v-list-item-avatar :color="getHTTPColor(cb.callback_http_method)">
        <span class="white--text">{{getHTTPMethod(cb.callback_http_method)}}</span>
      </v-list-item-avatar>
      <v-list-item-content v-if="!edit">
        <v-list-item-title>{{ base_uri + cb.callback_uri }}</v-list-item-title>
        <v-list-item-subtitle>{{getTAKTEntity(cb.takt_entity)}}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-content v-else>
        <StandardTextfield
          color="grey darken-1"
          textcolor="white"
          placeholder="CALLBACK.callback_uri"
          :value="cb.callback_uri"
          @changeValue="$emit('updateCallback', {data: {callback_uri: $event}, callback_id: cb.id})"
          style="width: 90%"
          />
      </v-list-item-content>
      <v-list-item-action>
        <slot name="remove-callback" :cb="cb" />
        <v-btn x-small @click="edit=!edit">edit</v-btn>
      </v-list-item-action>
    </v-list-item>
    <slot name="add-callback" />
  </v-list>
</template>
<script>
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import { mapGetters } from 'vuex';

export default {
  components: {
    StandardTextfield,
  },
  props: ['base_uri', 'callbacks'],
  data: () => ({
    edit: false
  }),
  computed: {
    ...mapGetters('Auth', [
      'hasPermission',
      'hasBusiness'
    ]),
  },
  methods: {
    getHTTPColor(method){
      switch (method) {
        case 'POST':
          return '#d89f39';
        case 'PUT':
          return '#3a81ba';
        case 'DELETE':
          return '#963334';
      }
    },
    getHTTPMethod(method){
      if (method === 'DELETE') {
        return 'DEL';
      }
      return method;
    },
    getTAKTEntityOptions(){
      let entities = [{name: 'Project WORK.package'}];
      if (this.hasPermission('Client TEST')) {
        entities.push({name: 'Project COST.step'});
        entities.push({name: 'Project LOGISTIC.step'});
        entities.push({name: 'Project DESIGN.step'});
        entities.push({name: 'Project HANDOVER.step'});
        entities.push({name: 'Project DEFECT.step'});
        entities.push({name: 'Project QUALITY.step'});
        entities.push({name: 'Project MATERIAL.step'});
        entities.push({name: 'Project WORK.step'});
        entities.push({name: 'Project Material'});
        entities.push({name: 'Project WAGON'});
        entities.push({name: 'Project TAKT.area'});
        entities.push({name: 'Project TRAIN'});
        entities.push({name: 'Company Sequence'});
        entities.push({name: 'Company Sequence Wagon'});
        entities.push({name: 'Company Sequence WORK.package'});
        entities.push({name: 'Company Sequence WORK.step'});
        entities.push({name: 'Company Sequence QUALITY.step'});
        entities.push({name: 'Company Sequence DEFECT.step'});
        entities.push({name: 'Company Sequence DESIGN.step'});
        entities.push({name: 'Company Sequence LOGISTIC.step'});
        entities.push({name: 'Company Sequence HANDOVER.step'});
        entities.push({name: 'Company Sequence COST.step'});
        entities.push({name: 'Company Sequence TOOL.step'});
        entities.push({name: 'Company Sequence MATERIAL.step'});
        entities.push({name: 'Company WORK.package'});
        entities.push({name: 'Company WORK.package WORK.step'});
        entities.push({name: 'Company WORK.package QUALITY.step'});
        entities.push({name: 'Company WORK.package DEFECT.step'});
        entities.push({name: 'Company WORK.package DESIGN.step'});
        entities.push({name: 'Company WORK.package LOGISTIC.step'});
        entities.push({name: 'Company WORK.package HANDOVER.step'});
        entities.push({name: 'Company WORK.package COST.step'});
        entities.push({name: 'Company WORK.package TOOL.step'});
        entities.push({name: 'Company WORK.package MATERIAL.step'});
      }
      return entities;
    },
    getTAKTEntity(entity){
      switch (entity) {
        case 'TWorkPackage':
          return 'Project WORK.package';
        case 'TWorkStep':
          return 'Project WORK.step';
        case 'TQualityStep':
          return 'Project QUALITY.step';
        case 'TDefectStep':
          return 'Project DEFECT.step';
        case 'TDesignStep':
          return 'Project DESIGN.step';
        case 'THandoverStep':
          return 'Project HANDOVER.step';
        case 'TLogisticStep':
          return 'Project LOGISTIC.step';
        case 'TCostStep':
          return 'Project COST.step';
        case 'TMaterialStep':
          return 'Project MATERIAL.step';
        case 'TMaterial':
          return 'Project Material';
        case 'TWaggon':
          return 'Project WAGON';
        case 'TaktArea':
          return 'Project TAKT.area';
        case 'Train':
          return 'Project TRAIN';
        case 'BSequence':
          return 'Company Sequence';
        case 'BSWaggon':
          return 'Company Sequence Wagon';
        case 'BSWorkPackage':
          return 'Company Sequence WORK.package';
        case 'BSWorkStep':
          return 'Company Sequence WORK.step';
        case 'BSQualityStep':
          return 'Company Sequence QUALITY.step';
        case 'BSDefectStep':
          return 'Company Sequence DEFECT.step';
        case 'BSDesignStep':
          return 'Company Sequence DESIGN.step';
        case 'BSLogisticStep':
          return 'Company Sequence LOGISTIC.step';
        case 'BSHandoverStep':
          return 'Company Sequence HANDOVER.step';
        case 'BSCostStep':
          return 'Company Sequence COST.step';
        case 'BSToolStep':
          return 'Company Sequence TOOL.step';
        case 'BSMaterialStep':
          return 'Company Sequence MATERIAL.step';
        case 'BWorkPackage':
          return 'Company WORK.package';
        case 'BWWorkStep':
          return 'Company WORK.package WORK.step';
        case 'BWQualityStep':
          return 'Company WORK.package QUALITY.step';
        case 'BWDefectStep':
          return 'Company WORK.package DEFECT.step';
        case 'BWDesignStep':
          return 'Company WORK.package DESIGN.step';
        case 'BWLogisticStep':
          return 'Company WORK.package LOGISTIC.step';
        case 'BWHandoverStep':
          return 'Company WORK.package HANDOVER.step';
        case 'BWCostStep':
          return 'Company WORK.package COST.step';
        case 'BWToolStep':
          return 'Company WORK.package TOOL.step';
        case 'BWMaterialStep':
          return 'Company WORK.package MATERIAL.step';

        default:
          return entity;
      }
    }
  }
}
</script>
<style scoped>

</style>
